"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var htmlparser = require('htmlparser2');
var domutils = require('domutils');
var utils = require('../utils/utils');
var v3TokenRegex = new RegExp('{# pers-token:1 ([^#]+) #}(.*?){# pers-token:1 #}', 'g');
exports.convertV1ToV3Token = function (template) {
    return convert(template, 1, 3);
};
exports.convertV3ToV1Token = function (template) {
    return convert(template, 3, 1);
};
exports.convertV2ToV3Token = function (template) {
    return convert(template, 2, 3);
};
exports.convertV3ToV2Token = function (template) {
    return convert(template, 3, 2);
};
function convert(template, versionFrom, versionTo) {
    var response = '';
    var handler = new htmlparser.DomHandler(function (error, dom) {
        if (error)
            console.log(error);
        else {
            dom.forEach(function (domElement) {
                replaceToken(domElement, versionFrom, versionTo);
            });
        }
        response = domutils.getOuterHTML(dom);
    });
    var parser = new htmlparser.Parser(handler);
    parser.write(utils.wrapTemplate(template));
    parser.end();
    return utils.unwrapTemplate(response);
}
function replaceToken(element, versionFrom, versionTo) {
    var newElement = null;
    switch (versionFrom + 'to' + versionTo) {
        case '1to3': {
            if (utils.isV1Element(element)) {
                newElement = getV3FromV1Element(element, versionFrom);
            }
            break;
        }
        case '2to3': {
            if (utils.isV2Element(element)) {
                newElement = getV3FromV2Element(element, versionFrom);
            }
            break;
        }
        case '3to2': {
            if (element.type !== "text" || !element.data) {
                break;
            }
            newElement = getV2FromV3Element(element);
            break;
        }
        case '3to1': {
            if (element.type !== "text" || !element.data) {
                break;
            }
            newElement = getV1FromV3Element(element);
            break;
        }
    }
    if (newElement !== null) {
        domutils.replaceElement(element, newElement);
    }
    if (element.children && element.children.length > 0) {
        element.children.forEach(function (childrenElement) {
            replaceToken(childrenElement, versionFrom, versionTo);
        });
    }
}
function getV3FromV1Element(element, versionFrom) {
    var childText = element.children[0].data;
    var newTokenData = getV3TokenData(element.attribs['e-personalization'], versionFrom, childText);
    return {
        type: 'text',
        data: utils.surroundPlaceholders(newTokenData.token.code, newTokenData)
    };
}
function getV3FromV2Element(element, versionFrom) {
    var childText = element.children[0].data;
    var newTokenData = getV3TokenData(decodeURI(element.attribs['token-meta']), versionFrom, childText);
    return {
        type: 'text',
        data: utils.surroundPlaceholders(newTokenData.token.code, newTokenData)
    };
}
function getV2FromV3Element(element) {
    var newData = element.data.replace(v3TokenRegex, function (match, hash) {
        var tokenData = utils.base64ToJson(hash);
        if ((tokenData.origin && tokenData.origin === 2) || tokenData.token.source === 'contact') {
            var newTokenData = getV2TokenData(tokenData);
            var tokenTemplate = '%22%3C%25=%20template%20%25%3E%22';
            var tokenContent = encodeURI("{\"template\":\"" + newTokenData.personalizationState.preview + "\"}");
            var tokenMeta = encodeURI(JSON.stringify(newTokenData));
            return "<span e-token=\"personalization\" token-template=\"" + tokenTemplate + "\" token-content=\"" + tokenContent + "\" token-meta=\"" + tokenMeta + "\" class=\"cbNonEditable\">" + tokenData.tokenName + "</span>";
        }
        return match;
    });
    return {
        type: 'text',
        data: newData
    };
}
function getV1FromV3Element(element) {
    var newData = element.data.replace(v3TokenRegex, function (match, hash) {
        var tokenData = utils.base64ToJson(hash);
        if ((tokenData.origin && tokenData.origin === 1) || tokenData.token.source === 'contact') {
            var field = tokenData.token.content.field;
            return "<span class=\"cbNonEditable\" e-personalization=\"" + field + "\">" + tokenData.tokenName + "</span>";
        }
        return match;
    });
    return {
        type: 'text',
        data: newData,
    };
}
function getV3TokenData(fromData, origin, text) {
    switch (origin) {
        case 1: {
            return {
                tokenName: text,
                type: 'personalization',
                origin: origin,
                token: {
                    name: text,
                    use_cases: [],
                    code: "{{ contact." + fromData + " }}",
                    filters: {
                        fallback: '',
                        required: false,
                        modifier: '',
                    },
                    source: 'contact',
                    content: getV3TokenContent('contact', { selectedField: "contact." + fromData }),
                }
            };
        }
        default:
        case 2: {
            var oldToken = JSON.parse(fromData).personalizationState;
            return {
                tokenName: text,
                type: 'personalization',
                origin: origin,
                token: {
                    name: oldToken.tokenName,
                    use_cases: [],
                    code: oldToken.preview,
                    filters: {
                        fallback: oldToken.modifier.fallbackText,
                        required: oldToken.modifier.requiredField,
                        modifier: oldToken.modifier.selectedModifier
                    },
                    source: oldToken.selectedTab,
                    content: getV3TokenContent(oldToken.selectedTab, oldToken.selectedContent)
                }
            };
        }
    }
}
function getV3TokenContent(source, content) {
    switch (source) {
        case 'contact':
            return {
                field: content.selectedField.replace('contact.', '')
            };
        case 'event':
            return {
                event_id: content.selectedEventId,
                variable: content.selectedVariable
            };
        case 'predict':
            return {
                preset_id: content.selectedPresetId,
                field_name: content.selectedFieldName
            };
        case 'rds':
            return {
                preset_id: content.selectedPresetId,
                field_name: content.selectedFieldName
            };
        case 'voucher':
            return {
                field: content.selectedField
            };
        default:
            console.log("Invalid source: " + source);
            return {};
    }
}
function getV2TokenData(fromData) {
    return {
        personalizationState: {
            tokenName: fromData.token.name,
            selectedTab: fromData.token.source,
            modifier: {
                selectedModifier: fromData.token.filters.modifier,
                requiredField: fromData.token.filters.required,
                fallbackText: fromData.token.filters.fallback
            },
            preview: fromData.token.code,
            selectedContent: getV2TokenContent(fromData.token.source, fromData.token.content)
        }
    };
}
function getV2TokenContent(source, content) {
    switch (source) {
        case 'contact':
            return {
                selectedField: 'contact.' + content.field
            };
        case 'event':
            return {
                selectedEventId: content.event_id,
                selectedVariable: content.variable
            };
        case 'predict':
            return {
                selectedPresetId: content.preset_id,
                selectedFieldName: content.field_name
            };
        case 'rds':
            return {
                selectedPresetId: content.preset_id,
                selectedFieldName: content.field_name
            };
        case 'voucher':
            return {
                selectedField: content.field
            };
        default:
            console.log("Invalid source: " + source);
            return {};
    }
}
//# sourceMappingURL=version-converter.js.map